const WORKER_ENABLED = areWorkersAvailable();

const wrapper = function () {
  const done = function (result) {
    self.postMessage(result);
    self.close();
  };
  /* eslint-disable no-undef */
  self.onmessage = function (msg) {
    const args = msg.data.slice();
    args.push(done);
    uf.apply(self, args);
  };
  /* eslint-disable no-undef */
};

let WorkerFunction;
if (WORKER_ENABLED) {
  WorkerFunction = function (fn) {
    return function WorkedFunction() {
      const args = Array.prototype.slice.call(arguments, 0);

      return new Promise(function (resolve, reject) {
        let fnStr = fn.toString();
        if (!/^function\s*/.test(fnStr)) fnStr = 'function ' + fnStr;
        const fnSrc = 'var uf = ' + fnStr + ';\n';
        const wSrc = 'var w = ' + wrapper.toString() + ';\n' + 'w();';
        const worker = new SrcWorker(fnSrc + wSrc);
        worker.onmessage = function (result) {
          resolve(result.data);
        };
        worker.onerror = function (err) {
          reject(err);
        };
        worker.postMessage(args);
      });
    };
  };
} else {
  console.warn('worker-function: BROWSER NOT SUPPORTED - falling back to non-worker methods');
  WorkerFunction = function (fn) {
    return function NonWorkedFunction() {
      const args = Array.prototype.slice.call(arguments, 0);

      return new Promise(function (resolve, reject) {
        try {
          args.push(resolve);
          fn.apply(null, args);
        } catch (e) {
          reject(e);
        }
      });
    };
  };
}

function areWorkersAvailable() {
  const available = !!(window.URL && window.Blob && window.Worker);
  if (available) {
    // One more test
    try {
      const worker = new SrcWorker('');
      worker.terminate();
    } catch (err) {
      return false;
    }
  }
  return available;
}

function SrcWorker(src) {
  return new window.Worker(window.URL.createObjectURL(new window.Blob([src], { type: 'text/javascript' })));
}

export default WorkerFunction;
